/**
 * Convert numeric certainty to letter grade
 */
export function certaintyToGrade(certainty) {
  if (certainty == null) return 'F';
  const value = parseFloat(certainty);
  if (isNaN(value)) return 'F';
  if (value >= 98) return 'A+';
  if (value >= 90) return 'A';
  return 'F';
}
